const Theme = {
    body_background_color: '#FFA033',

    header_padding: '5',

    logo_image_url: 'rdvhist.png',
    logo_height: 250,

    token_url: 'rdvhist.png',
    token_width: 60,

    number_hidden: true,

    button_color: '#FFA033',

    button_half_border_color: '#FFA033',

    text_font: `'Roboto', sans-serif`,

    title_font: `'Roboto', sans-serif`,

    subtitle_font: `'Roboto', sans-serif`,

  }

  export default Theme
